var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listPage overflow-hidden" },
    [
      _vm.tabName === 2 || _vm.tabName === 3 || _vm.tabName === 4
        ? _c("MessageList", {
            ref: "messageList",
            attrs: { tabName: _vm.tabName, entitiesType: _vm.typeSelected },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }